<style lang="less" scoped>
.margin-tb {
  height: 32px;
  margin-top: 4px;
}
.title-div {
  font-weight: 600;
  margin: 20px 0;
  font-size: 26px;
  flex-grow: 1;
  color: #000;
  height: 30px;
}
.el-dialog__body {
  padding:10px 40px 40px;
}
.msg_con{
  min-height: 200px;
  width: 50%;
  padding-left: 50px;
  div{
    margin-top: 10px;
  }
  table{
    margin-top: 20px;
    tr{
      th{
      border: 1px solid #eaeaea; 
      background: #FAFAFA;
      color: #8F9BB3;
      }
      td{
      border: 1px solid #eaeaea; 
      color: #8F9BB3;
      }
    }
  }
}
.msg_con:first-of-type{
  padding-right: 50px;
  border-right: 1px solid #eeeff3;
}

</style>

<template>
  <div>
      <div class="title-div">故障信息</div>
      <!-- 筛选 -->
      <div class="page-action-btns flex margin-tb-10">
        <div class="flex-grow-1"></div>
        <el-date-picker
            size="small"
            placeholder="请选择故障日期"
            type="date"
            value-format="yyyy-MM-dd"
            v-model="queryInfo.dtFrom">
        </el-date-picker>
        <el-button type="primary" size="small" @click="getListData(pagination, true)">
          搜 索
        </el-button>
      </div>
      <!-- 表格 -->
        <ZD-table
          :tableColumns="pageConfig.faultDetailColumns"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.tableConfig"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "
        ></ZD-table>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
      <!-- 操作日志 -->
      <el-dialog title="查看报文" width="60%" :visible.sync="showDialog">
        <div class="flex">
          <div class="msg_con">
              <div class="flex">
                <div class="title">第一条消息类型名称:</div>
                <div>{{logInfo.firstMessageTypeName}}</div>
              </div>
              <div class="flex">
                <div class="title">第一条消息:</div>
                <div>{{logInfo.firstMessage }}</div>
              </div>
              <table border='1' cellpadding="10" cellspacing='0' style="width:100%;text-align:center;border:1px solid #eaeaea">
                <tr>
                  <th>字段</th>
                  <th>解析内容</th>
                </tr>
                <tr>
                  <td>桩状态</td>
                  <td>{{logInfo.pileStatusName}}</td>
                </tr>
                <tr>
                  <td>故障描述</td>
                  <td>{{logInfo.remark}}</td>
                </tr>
              </table>
          </div>
          <div class="msg_con">
              <div class="flex">
                <div class="title">第二条消息类型名称:</div>
                <div>{{logInfo.firstMessageTypeName}}</div>
              </div>
              <div class="flex">
                <div class="title">第二条消息:</div>
                <div>{{logInfo.firstMessage }}</div>
              </div>
              <table border cellspacing='0' style="width:100%;text-align:center;border:1px solid #eaeaea">
                <tr>
                  <th>字段</th>
                  <th>解析内容</th>
                </tr>
                <tr>
                  <td>桩状态</td>
                  <td>{{logInfo.pileStatusName}}</td>
                </tr>
                <tr>
                  <td>故障描述</td>
                  <td>{{logInfo.remark}}</td>
                </tr>
              </table>
          </div>
        </div>

      </el-dialog>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      showMultiQuerys:false,//高级筛选
      queryInfo: {}, //标签页 搜索字段
      showDialog: false, //弹窗
      dealerVisible: false, //分配运营商弹窗
      selectLabelVisible: false, //选择标签弹窗
      labelName: "11", //	未使用
      labelForm: {}, //标签管理内容
      dealerForm: {}, //分配运营商内容
      checkList: [], //选中标签
      labelsArr: [], //客户标签
      selectLabelForm: {}, //所有标签内容
      labelSum: 0, //合计客户数量 默认0
      operates: {
        width: 220,
        fixed: "right",
        list: [
          {
            id: "check",
            label: "报文查看",
            type: "primary",
            show: true,
            disabled: false,
            method: (index, row) => {
                this.toDetail(row);
            },
          }, 
        ],
      },
      searchTime: [], //注册时间
      firstSearchTime: [], //首次充电时间
      lastSearchTime: [], //最近充电时间
      options: [], //未使用
      value: [], //未使用
      pileList: [], //桩列表
      loading: false, //未使用
      dealNameArr: [], //未使用
      dealerList: [], //未使用
      logInfo:{
        firstMessageTypeName:'1111',
        errorDesc:'234'
      
      }
      //btnUse: false,
    };
  },
  methods: {
    init() {
      // this.getPileList();
      this.pileCode = this.$store.state.pileObj.pileCode
      this.getListData(this.pagination, true);
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pileCode = _.pileCode
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        this.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      // _.queryInfo.corpNo = _.$store.state.corpNo;
      // _.$H.post(_, _.$A.cust.pagecust, _.queryInfo).then((res) => {
      _.$H.post(_, _.$A.pile.getErrorInfo, _.queryInfo).then((res) => {
        console.log(res);
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    toDetail(row){
      this.logInfo = row
      this.showDialog = true
    }
  },
  mounted() {
    this.init();
  },
};
</script>
